import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  EmailSettingById,
  EmailSettingByIdVariables
} from "./types/EmailSettingById";
import {
  emailSettingsList,
  emailSettingsListVariables
} from "./types/emailSettingsList";

const emailSettingById = gql`
  query EmailSettingById($id: ID!) {
    emailSettingById(id: $id) {
      id
      name
      sendFrequency
      emailType
      template
      subject
      description
      lastChange
    }
  }
`;

export const useEmailSettingByIdQuery = makeQuery<
  EmailSettingById,
  EmailSettingByIdVariables
>(emailSettingById);

const EmailSettingsList = gql`
  fragment PageInfoFragment on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
  query emailSettingsList(
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    emailSettings(before: $before, after: $after, first: $first, last: $last) {
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
      edges {
        node {
          id
          name
          sendFrequency
          emailType
          template
          subject
          description
          lastChange
        }
      }
    }
  }
`;
export const useEmailSettingsListQuery = makeQuery<
  emailSettingsList,
  emailSettingsListVariables
>(EmailSettingsList);

export const emailSendTest = gql`
  query EmailTest($emailName: String) {
    emailTest(emailName: $emailName)
  }
`;
